module.exports = [{
      plugin: require('/Users/jsaussy/learn/year-recap/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
